import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Download } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";

export const ImportAreaDialog = () => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ woonplaats: "", postcode: "", limit: 50 });
  const [busy, setBusy] = useState(false);
  const qc = useQueryClient();
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/addresses/import-area", {
        woonplaats: form.woonplaats || null, postcode: form.postcode || null, limit: Number(form.limit) });
      toast.success(`Import gestart: ${data.total} adressen worden gekoppeld aan percelen`);
      qc.invalidateQueries({ queryKey: ["jobs"] });
      setOpen(false);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button data-testid="open-import-area-btn" className="flex items-center gap-2 h-10 px-4 rounded-md border border-slate-700 hover:border-blue-500 transition-colors text-sm">
          <Download className="h-4 w-4" /> Import per woonplaats / postcode
        </button>
      </DialogTrigger>
      <DialogContent className="bg-slate-900/95 backdrop-blur-md border-slate-700" data-testid="import-area-modal">
        <DialogHeader><DialogTitle className="font-display text-xl">Adressen importeren uit BAG</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <label className="block text-xs text-slate-400">Woonplaats
            <Input data-testid="import-woonplaats-input" value={form.woonplaats} onChange={set("woonplaats")} placeholder="bv. Ameide" className="mt-1.5 bg-slate-950 border-slate-800" />
          </label>
          <label className="block text-xs text-slate-400">Postcode (4 cijfers of volledig, optioneel)
            <Input data-testid="import-postcode-input" value={form.postcode} onChange={set("postcode")} placeholder="bv. 4233 of 4233GB" className="mt-1.5 bg-slate-950 border-slate-800" />
          </label>
          <label className="block text-xs text-slate-400">Maximaal aantal adressen (max 500)
            <Input data-testid="import-limit-input" type="number" min={1} max={500} value={form.limit} onChange={set("limit")} className="mt-1.5 bg-slate-950 border-slate-800" />
          </label>
          <p className="text-[11px] text-slate-500">Per adres wordt automatisch het kadastrale perceel (BRK) en de BAG-panden opgehaald.</p>
          <button data-testid="import-area-submit-btn" disabled={busy} className="w-full h-10 rounded-md bg-blue-600 hover:bg-blue-500 text-sm font-medium disabled:opacity-60">
            {busy ? "Bezig…" : "Import starten"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
